import { isAxiosError } from 'axios';
import { SynonymError, SynonymWarning } from '../../../lib/api/searchDictionary';

/**
 * 검색 사전 API 오류 읽기 (AMZUWEB-694).
 *
 * 백엔드 전역 예외 필터가 본문을 `{ errors: [{ code, message }] }` 로 다시 만들기 때문에,
 * 화면이 다시 판단하는 데 필요한 정보는 **`errorDetails`** 에만 실려 온다.
 *  - 400 → `errorDetails.errors` (토큰별 저장 차단 사유)
 *  - 409 → `errorDetails.current` (지금 저장된 토큰 — 그 사이 다른 사람이 바꿈). 없으면 잠금 충돌
 *  - 422 → `errorDetails.warnings` (확인하고 저장해야 할 경고)
 */
export type SearchDictionaryApiError = {
  status: number | null;
  /** 요약 문구 — 서버가 준 첫 메시지, 없으면 기본 문구 */
  message: string;
  errors: SynonymError[];
  warnings: SynonymWarning[];
  /** 409 일 때 지금 저장된 토큰. 잠금 충돌이면 null */
  current: string[] | null;
};

type ErrorBody = {
  errors?: { code?: string; message?: string }[];
  errorDetails?: { errors?: SynonymError[]; warnings?: SynonymWarning[]; current?: string[] };
};

export const readApiError = (
  error: unknown,
  fallback = '처리하지 못했습니다. 잠시 뒤 다시 시도해 주세요.',
): SearchDictionaryApiError => {
  if (!isAxiosError<ErrorBody>(error)) {
    return { status: null, message: fallback, errors: [], warnings: [], current: null };
  }
  const body = error.response?.data;
  return {
    status: error.response?.status ?? null,
    message: body?.errors?.[0]?.message || fallback,
    errors: body?.errorDetails?.errors ?? [],
    warnings: body?.errorDetails?.warnings ?? [],
    current: body?.errorDetails?.current ?? null,
  };
};
